import React, { useState, useEffect } from "react";
import i18n from "i18next";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import moment from "moment";
import AddEditActivityView from "./AddEditActivityView";
import {
  activityType,
  ACTIVITY_GROUP,
  add,
  dateConfig,
  edit,
  SET_EMPTY as EMPTY,
} from "../../config/index";
import { getActivity } from "utils/activity";
import { useSelector, useDispatch } from "react-redux";
import { getActivityGroups, getJobFamilies } from "../../redux/actions/appActions";
import { getActivityGroupByLanguage } from "../../utils/punch";
import { MANAGE_ACTIVITY_GROUP,IMPROJECTDATA } from "../../navigation/CONSTANTS";
import { addNewActivityGroup, editActivityGroup } from "services";

export const AddEditActivityContainer = () => {
  const methods = useForm({
    mode: "all",
  });
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const appConfig = useSelector((state) => state.appConfig);
  const user = useSelector((state) => state.user);
  const loggedInSupervisor = user.auth.user;
  const dispatch = useDispatch();
  const [name, setName] = useState(EMPTY);
  const [type, setType] = useState(-1);
  const [startDate, setStartDate] = useState(null);
  const [startDateErr, setStartDateErr] = useState(false);
  const [startDateErrMsg, setStartDateErrMsg] = useState(EMPTY);
  const [endDate, setEndDate] = useState(null);
  const [endDateErr, setEndDateErr] = useState(false);
  const [endDateErrMsg, setEndDateErrMsg] = useState(EMPTY);
  const [isActive, setIsActive] = useState(true);
  const [isJobFamilyRestricted, setIsJobFamilyRestricted] = useState(false);
  const [jobFamily, setJobFamily] = useState([]);
  const [pageTitle, setPageTitle] = useState(EMPTY);
  const [disableSave, setDisableSave] = useState(true);
  const [mode, setMode] = useState(add);
  const [loading, setLoading] = useState(false);
  const [backendErr, setBackendErr] = useState(false);
  const [success, setSuccess] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [nameErrMsg, setNameErrMsg] = useState(EMPTY);
  const [isProjectData, setIsProjectData] = useState(false);
  let activityGroupOptions = getActivityGroupByLanguage(
    i18n.language,
    ACTIVITY_GROUP
  );
  const defaultAG = [{ label: t("general.select4"), value: -1 }];
  const [activityDetails, setActivityDetails] = useState(location.state);
  const [confirmationMsg, setConfirmationMsg] = useState(EMPTY);
  const [isDistrictRestricted, setIsDistrictRestricted] = useState(false);
  const [restrictedDistricts, setRestrictedDistricts] = useState([]);
  const [defaultRestrictedDistricts, setDefaultRestrictedDistricts] = useState([]);
  // console.log("activityDetails :", activityDetails);

  // declarations over

  // get all drop-down values from back end
  try {
    if (appConfig !== null && appConfig.activityGroups !== null) {
      activityGroupOptions = getActivityGroupByLanguage(
        i18n.language,
        appConfig.activityGroups
      );
      activityGroupOptions = defaultAG.concat(activityGroupOptions.filter(item=>item.isDetailsEnabled));
    }
  } catch (error) {
    console.warn("error in appconfig setting default", appConfig);
    activityGroupOptions = getActivityGroupByLanguage(
      i18n.language,
      ACTIVITY_GROUP
    ); // setting defaults
  }

  const backHandler = () => {
    // history.push(REVIEW, { isManageActivityGroup: true });
    history.push(MANAGE_ACTIVITY_GROUP, { isManageActivityGroup: true });
  };

  const onChangeType = (event) => {
    const type = event.target.value;
    setType(type);
    // console.log(type);
  };

  const onChangeName = (event) => {
    const name = event.target.value;
    setName(name); // console.log(name);
    validateName(name);
  };

  // const onChangeStartDate = (date) => {
  //   let value = moment(date).format(dateConfig.format8);
  //   date = new Date(value);
  //   if (moment(date).isValid()) {
  //     setStartDate(date);
  //     setStartDateErr(false);
  //     setStartDateErrMsg(EMPTY);
  //   } else {
  //     setStartDateErr(true);
  //     setStartDateErrMsg(t("other.errInvalidDate"));
  //     setDisableSave(true);
  //   }
  // };

  // const onChangeEndDate = (date) => {
  //   let value = moment(date).format(dateConfig.format6);
  //   date = new Date(value);
  //   if (moment(date).isValid()) {
  //     setEndDate(date);
  //     setEndDateErr(false);
  //     setEndDateErrMsg(EMPTY);
  //   } else {
  //     setEndDate(null);
  //     setEndDateErr(true);
  //     setEndDateErrMsg(t("other.errInvalidDate"));
  //   }
  // };

  const onChangeIsActive = (event) => {
    const value = event.target.checked;
    setIsActive(value);
  };

  const onSave = () => {     
    const newActivity = getActivity(
      type,
      name,
      startDate,
      endDate,
      isActive,
      loggedInSupervisor.firstName,
      loggedInSupervisor.lastName,
      loggedInSupervisor.workerId,
      loggedInSupervisor.email,
      loggedInSupervisor.country,
      loggedInSupervisor.workerId,
      activityType.new,
      new Date().toISOString(),
      isJobFamilyRestricted,
      jobFamily,
      isDistrictRestricted,
      restrictedDistricts
    );

    if (mode === add) {
      // save new activity
      newActivity.actionType = activityType.new;
      // console.log("addNewActivityGroup :", addNewActivityGroup);
      setLoading(true);
      addNewActivityGroup(newActivity)
        .then((data) => {
          // console.log(data);
          setLoading(false);
          setSuccess(true);
          setConfirmationMsg(t("other.msgAdded"));
        })
        .catch((err) => {
          console.log(err);
          setBackendErr(true);
          setLoading(false);
        });
    } else if (mode === edit) {
      // update existing activity      
      newActivity.actionType = activityType.edit;
      setLoading(true);
      editActivityGroup(activityDetails.data.id, newActivity)
        .then((data) => {
          setLoading(false);
          setSuccess(true);
          setConfirmationMsg(t("other.msgUpdated"));
        })
        .catch((err) => {
          console.log(err);
          setBackendErr(true);
          setLoading(false);
        });

      // console.log("edit", newActivity);
    }
    // console.log(newActivity);
  };

  const onCancel = () => {
    // history.push(REVIEW, { isManageActivityGroup: true });
    history.push(MANAGE_ACTIVITY_GROUP, { isManageActivityGroup: true });
  };

  const validateForm = () => {
    if (type == -1 || name == EMPTY || endDateErr == true || startDateErr == true ||(isJobFamilyRestricted && jobFamily.length ===0) ||(isDistrictRestricted && restrictedDistricts.length ===0)) {
      return true;
    } else {
      return false;
    }
  };

  const validateDate = () => {
    if (startDate === null && endDate === null) {
      setEndDateErrMsg(EMPTY);
      setEndDateErr(false);
      setStartDateErrMsg(EMPTY);
      setStartDateErr(false);
      // } else if (startDate === null && endDate !== null) {
      //   setStartDateErrMsg("Invalid date");
      //   setStartDateErr(true);
      // } else if (endDate === null && startDate !== null) {
      //   setEndDateErrMsg("Invalid date");
      //   setEndDateErr(true);
    } else if (startDate && endDate && endDate < startDate) {
      setEndDateErrMsg(t("other.errDate"));
      setEndDateErr(true);
    }
  };

  const validateName = (name) => {
    if (name == EMPTY) {
      setNameErr(true);
      setNameErrMsg("Required");
    } else {
      setNameErr(false);
      setNameErrMsg(EMPTY);
    }
  };

  const populateFormWithExistingDetails = (activityDetails) => {
    setType(activityDetails.data.activityGroup);
    setName(activityDetails.data.name);
    if (activityDetails.data.startTS != null) {
      setStartDate(new Date(activityDetails.data.startTS));
    }

    if (activityDetails.data.endTS != null) {
      setEndDate(new Date(activityDetails.data.endTS));
    }
    setIsActive(activityDetails.data.isActive);
    if (activityDetails.data?.isJobRoleRestricted){
      setIsJobFamilyRestricted(activityDetails.data?.isJobRoleRestricted);
    }else {
      setIsJobFamilyRestricted(false);
    }

    if (activityDetails.data?.isDistrictRestricted){
      setIsDistrictRestricted(activityDetails.data?.isDistrictRestricted);
    }else {
      setIsDistrictRestricted(false);
    }
     
     setJobFamily(activityDetails.data?.jobRoles || []);
     setRestrictedDistricts(activityDetails.data?.restrictedDistricts || [])
     setDefaultRestrictedDistricts(activityDetails.data?.defaultRestrictedDistricts || [])
     console.log("defaultRestrictedDistricts",activityDetails.data.defaultRestrictedDistricts  );
     
     if (activityDetails.data && activityDetails.data.createdBy === IMPROJECTDATA){
      setIsProjectData(true);
    }else {
      setIsProjectData(false);
    }
  };

  // functions over

  // gets activity groups based on lang from backend
  useEffect(() => {
    if (appConfig != null && appConfig.activityGroups == null) {
      dispatch(getActivityGroups());
    }
    if (appConfig != null && appConfig.jobFamilies == null) {
      dispatch(getJobFamilies());
    }

  }, []);

  // set page title based on mode

  useEffect(() => {
    if (activityDetails && activityDetails.mode === edit) {
      // console.log("activityDetails :", activityDetails);
      setPageTitle(t("other.tlEdit"));
      setMode(edit);
      populateFormWithExistingDetails(activityDetails);
    } else {
      setPageTitle(t("other.tlAdd"));
      setMode(add);
    }
  }, [activityDetails]);

  // tracks changes in any form field and validates
  useEffect(() => {
    validateDate();
    setDisableSave(validateForm());
  }, [type, name, startDate, endDate, isActive,startDateErr, endDateErr ,
    jobFamily,isJobFamilyRestricted,isDistrictRestricted,restrictedDistricts]);

  return (
    <FormProvider {...methods}>
    <AddEditActivityView
      backHandler={backHandler}
      pageTitle={pageTitle}
      activityGroupOptions={activityGroupOptions}
      name={name}
      onChangeName={onChangeName}
      type={type}
      onChangeType={onChangeType}
      startDate={startDate}
      setStartDate = {setStartDate}
     //  onChangeStartDate={onChangeStartDate}
      startDateErr={startDateErr}
      setStartDateErr = {setStartDateErr}
      startDateErrMsg={startDateErrMsg}
      setStartDateErrMsg = {setStartDateErrMsg}
      endDate={endDate}
      setEndDate={setEndDate}
      endDateErr={endDateErr}
      endDateErrMsg={endDateErrMsg}
      setType={setType}
      setEndDateErrMsg = {setEndDateErrMsg}
      setEndDateErr ={setEndDateErr}
      // onChangeEndDate={onChangeEndDate}
      isActive={isActive}
      isJobFamilyRestricted ={isJobFamilyRestricted}
      setIsJobFamilyRestricted={setIsJobFamilyRestricted}
      jobFamily={jobFamily}
      setJobFamily={setJobFamily}
      onChangeIsActive={onChangeIsActive}
      onSave={onSave}
      disableSave={disableSave}
      onCancel={onCancel}
      mode={mode}
      
      loading={loading}
      backendErr={backendErr}
      success={success}
      onSuccess={backHandler}
      nameErr={nameErr}
      nameErrMsg={nameErrMsg}
      confirmationMsg={confirmationMsg}
      isDistrictRestricted={isDistrictRestricted}
      setIsDistrictRestricted={setIsDistrictRestricted}
      restrictedDistricts={restrictedDistricts}
      setRestrictedDistricts={setRestrictedDistricts}
      isProjectData={isProjectData}
      defaultRestrictedDistricts={defaultRestrictedDistricts}
    ></AddEditActivityView>
    </FormProvider>
    
  );
};

export default AddEditActivityContainer;
